export const forgotPassword = gql`
    mutation forgotPassword(
        $email: String
    ) {
        forgotPassword(
            input:{
                email: $email,
            }) {
            status
            message
        }
    }
`
